import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchRestaurantFooter } from "../../actions/footerActions";

import {
  useSelector,
} from "react-redux";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import "./css/Footer.css";


function Footer() {

  const {
    restaurantId,
    tableId,
  } = useParams();


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const footer = useSelector((state) => state.footer?.data);
  useEffect(() => {
    if (restaurantId) dispatch(fetchRestaurantFooter(restaurantId)).catch(() => {});
  }, [dispatch, restaurantId]);


  const {
    restaurantName,
  } = useSelector(
    (state) => state.menu
  );


  const homePath =
    `/${restaurantId}/table/${tableId}`;


  const goHome = () => {

    navigate(
      homePath
    );

  };


  const goCart = () => {

    navigate(
      `${homePath}/cart`
    );

  };


  const scrollToSection = (
    sectionId
  ) => {

    const section =
      document.getElementById(
        sectionId
      );


    if (section) {

      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

    }

  };


  return (

    <footer
      className="theme3-footer"
    >


      {/* =================================================
          MAIN FOOTER
      ================================================= */}

      <div className="theme3-footer-main">


        {/* BRAND */}

        <div className="theme3-footer-brand">

          <button
            type="button"
            onClick={goHome}
            className="theme3-footer-logo"
          >

            <span>
              ✦
            </span>

            <strong>
              {footer?.restaurant_name || restaurantName || "OUR RESTAURANT"}
            </strong>

          </button>


          <p>
            {footer?.description || ""}
          </p>

        </div>


        {/* LINKS */}

        <div className="theme3-footer-column">

          <span>
            EXPLORE
          </span>


          <button
            type="button"
            onClick={goHome}
          >
            HOME
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "story"
              )
            }
          >
            OUR STORY
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "menu"
              )
            }
          >
            MENU
          </button>


          <button
            type="button"
            onClick={() =>
              scrollToSection(
                "gallery"
              )
            }
          >
            GALLERY
          </button>

        </div>


        {/* VISIT */}

        <div className="theme3-footer-column">

          <span>
            VISIT US
          </span>


          <p>
            {footer?.address || ""}
          </p>


          <p>
            {footer?.monday_friday_hours || footer?.opening_hours || ""}
          </p>

        </div>


        {/* CONTACT */}

        <div className="theme3-footer-column">

          <span>
            CONTACT
          </span>


          <p>
            {footer?.phone || ""}
          </p>


          <p>
            {footer?.email || ""}
          </p>


          <button
            type="button"
            onClick={goCart}
            className="theme3-footer-order"
          >
            YOUR ORDER →
          </button>

        </div>


      </div>


      <p className="theme3-footer-disclaimer" style={{textAlign:"center",padding:"12px 16px",fontSize:"11px",opacity:0.75}}>
        {footer?.disclaimer || "Food images are for presentation purposes only. Actual items may vary."}
      </p>
      {/* =================================================
          FOOTER BOTTOM
      ================================================= */}

      <div className="theme3-footer-bottom">

        <span>
          © {new Date().getFullYear()}{" "}
          {footer?.restaurant_name || restaurantName || "OUR RESTAURANT"}
        </span>


        <span>
          AUTHENTIC FLAVOURS ·
          TIMELESS TRADITIONS
        </span>

      </div>


    
      {/* Restaurant social profiles (only show configured HTTPS/HTTP URLs) */}
      {[
        { field: "facebook_url", label: "Facebook", glyph: "f" },
        { field: "instagram_url", label: "Instagram", glyph: "◎" },
        { field: "youtube_url", label: "YouTube", glyph: "▶" },
        { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
      ].some(({ field }) => /^https?:\/\//i.test((footer?.[field] || "").trim())) && (
        <nav aria-label="Restaurant social media" style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", alignItems: "center", gap: "14px", padding: "14px 18px" }}>
          {[
            { field: "facebook_url", label: "Facebook", glyph: "f" },
            { field: "instagram_url", label: "Instagram", glyph: "◎" },
            { field: "youtube_url", label: "YouTube", glyph: "▶" },
            { field: "whatsapp_url", label: "WhatsApp", glyph: "◉" },
          ].filter(({ field }) => /^https?:\/\//i.test((footer?.[field] || "").trim())).map(({ field, label, glyph }) => (
            <a key={field} href={footer[field].trim()} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}
               style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: "32px", minHeight: "32px", color: "inherit", textDecoration: "none", fontWeight: 700, fontSize: "20px" }}>
              {glyph}
            </a>
          ))}
        </nav>
      )}
    </footer>

  );

}


export default Footer;